import { chartKeys } from 'utils/constant';

const best_worst_trade = {
  chartTitle: 'Best Worst Trades',
  chartKey: chartKeys.BEST_WORST_TRADE,
}

export default best_worst_trade;